import React from 'react'
import BaseIcon from 'react-icon-base'

const NZ = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>NZ</title>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <path id="c" d="M.033.043h9.934v6.519H.033z" />
      <path
        id="e"
        d="M.033.043L5 3.303H.033V.043zM5 .043h4.967L5 3.303V.043zm0 3.26h4.967v3.26L5 3.303zm0 0v3.26H.033L5 3.303z"
      />
      <rect id="g" width="20" height="14" x=".5" y=".5" rx="2" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#00297B" xlinkHref="#a" />
      <g mask="url(#b)">
        <path fill="#00247D" fillRule="nonzero" d="M.05.05h21v15h-21z" />
        <g>
          <mask id="d" fill="#fff">
            <use xlinkHref="#c" />
          </mask>
          <path
            fill="#000"
            fillRule="nonzero"
            stroke="#FFF"
            strokeWidth="1.49"
            d="M.033.043l9.934 6.52m-9.934 0L9.967.043"
            mask="url(#d)"
          />
        </g>
        <g>
          <mask id="f" fill="#fff">
            <use xlinkHref="#e" />
          </mask>
          <path
            fill="#000"
            fillRule="nonzero"
            stroke="#CC142B"
            strokeWidth=".993"
            d="M.033.043l9.934 6.52m-9.934 0L9.967.043"
            mask="url(#f)"
          />
        </g>
        <path fill="#000" fillRule="nonzero" stroke="#FFF" strokeWidth="2.483" d="M5.022.043v6.52M.033 3.31h9.934" />
        <path fill="#000" fillRule="nonzero" stroke="#CC142B" strokeWidth="1.49" d="M5.022.043v6.52M.033 3.31h9.934" />
        <g fillRule="nonzero">
          <path fill="#FFF" d="M17.348 5.27l.62.45-.236.729.62-.45.62.45-.237-.73.62-.45h-.766l-.237-.729-.237.73z" />
          <path
            fill="#CC142B"
            d="M17.73 5.393l.385.28-.147.45.384-.278.384.278-.147-.45.384-.28h-.475l-.146-.45-.147.45z"
          />
          <path
            fill="#FFF"
            d="M14.273 2.663l.697.507-.266.819.697-.506.697.506-.267-.82.697-.506h-.861l-.266-.819-.266.82z"
          />
          <path
            fill="#CC142B"
            d="M14.656 2.788l.46.334-.176.542.46-.335.461.335-.176-.542.46-.334h-.568l-.176-.542-.176.542z"
          />
          <path
            fill="#FFF"
            d="M10.83 6.127l.697.507-.266.819.697-.506.697.506-.267-.82.697-.506h-.861l-.266-.819-.267.82z"
          />
          <path
            fill="#CC142B"
            d="M11.213 6.252l.46.334-.176.542.46-.335.461.335-.176-.542.46-.334h-.568l-.176-.542-.176.542z"
          />
          <path
            fill="#FFF"
            d="M14.149 11.564l.774.562-.296.909.774-.562.773.562-.295-.91.773-.561h-.956l-.295-.91-.296.91z"
          />
          <path
            fill="#CC142B"
            d="M14.531 11.688l.538.39-.206.632.538-.39.537.39-.205-.632.537-.39h-.664l-.205-.632-.206.632z"
          />
        </g>
      </g>
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#g" />
    </g>
  </BaseIcon>
)

export default NZ
